import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {


  client_role: any = {
    title: '',
    level: 0,
    colour: '',
    description: ''
  }



  constructor(private modalController: ModalController,private apiService: ApiService) { }

  ngOnInit() {
    
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async Create() {
    let data: any = await this.apiService.post('firms/clients/roles',this.client_role);
    console.log(data);
    if(data.success) {
      this.modalController.dismiss(data.data);
    }
  }

}
